"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "colico": {
    "53e3f3aa": [{
      "hkey": "6117f9c7",
      "slug": "colico",
      "name": "Colico",
      "primary": true,
      "skipSearch": false
    }],
    "abbazia-piona": [{
      "hkey": "6117f9c7",
      "slug": "colico",
      "name": "Colico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f6b2c8ee": [{
      "hkey": "6117f9c7",
      "slug": "colico",
      "name": "Colico",
      "primary": true,
      "skipSearch": false
    }],
    "curcio": [{
      "hkey": "6117f9c7",
      "slug": "colico",
      "name": "Colico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ce3f1888": [{
      "hkey": "6117f9c7",
      "slug": "colico",
      "name": "Colico",
      "primary": true,
      "skipSearch": false
    }],
    "laghetto": [{
      "hkey": "6117f9c7",
      "slug": "colico",
      "name": "Colico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6a2415cd": [{
      "hkey": "6117f9c7",
      "slug": "colico",
      "name": "Colico",
      "primary": true,
      "skipSearch": false
    }],
    "olgiasca": [{
      "hkey": "6117f9c7",
      "slug": "colico",
      "name": "Colico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2e0ddedb": [{
      "hkey": "6117f9c7",
      "slug": "colico",
      "name": "Colico",
      "primary": true,
      "skipSearch": false
    }],
    "villatico": [{
      "hkey": "6117f9c7",
      "slug": "colico",
      "name": "Colico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;